/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDna = createReactComponent("outline", "dna", "IconDna", [["path", { "d": "M14.828 14.828a4 4 0 1 0 -5.656 -5.656a4 4 0 0 0 5.656 5.656z", "key": "svg-0" }], ["path", { "d": "M9.172 20.485a4 4 0 1 0 -5.657 -5.657", "key": "svg-1" }], ["path", { "d": "M14.828 3.515a4 4 0 0 0 5.657 5.657", "key": "svg-2" }]]);

export { IconDna as default };
//# sourceMappingURL=IconDna.mjs.map
